import React from 'react';

const Contact = () => {
  return <h1>Hello , I am a Contact Page</h1>
};

export default Contact;
